namespace Nobox {
    export interface RemoveAgentFromConversationClass {
        Delete?: Serenity.DeleteRequest;
        Msg?: ChatmessagesRow;
    }
}
